import { useMemo } from "react";

import { startCase } from "lodash";
import moment from "moment";

import type { OptionContract } from "~/v2/api/rest/data";

export interface ContractDisplayResult {
  strikeAndType: string;
  expirationDate: string;
}

export const getContractDisplay = (
  contract: OptionContract | undefined,
): ContractDisplayResult => {
  if (!contract) {
    return { strikeAndType: "", expirationDate: "" };
  }

  return {
    strikeAndType: `$${contract.strike_price} ${startCase(contract.type)}`,
    expirationDate: moment(contract.expiration_date).format("MM/DD/YY"),
  };
};

export const useContractDisplay = (contract: OptionContract | undefined) =>
  useMemo(() => getContractDisplay(contract), [contract]);
